// extracted by mini-css-extract-plugin
export var closeButton = "_md-1";
export var closeX = "_md-3";
export var container = "_md-0";
export var image = "_md-2";